import Cookies from 'js-cookie';

export const saveToken = (token) => {
  try {
    if (token) {
      Cookies.set('token', token);
      console.log('Token saved successfully:', token);
    }
  } catch (error) {
    console.error('Failed to save token:', error);
  }
};

export const getToken = () => {
  try {
    const token = Cookies.get('token');
    if (token) {
      console.log('Token retrieved successfully');
      return token;
    }
    return null;
  } catch (error) {
    console.error('Failed to get token:', error);
    return null;
  }
};

export const removeToken = () => {
  try {
    Cookies.remove('token', { path: '/' });
    console.log('Token removed successfully');
  } catch (error) {
    console.error('Failed to remove token:', error);
  }
};

export const saveIsBlocked = (isBlocked) => {
  try {
    Cookies.set('isBlocked', isBlocked.toString(), { expires: 7 }); // Expires in 7 days
    console.log('isBlocked saved successfully:', isBlocked);
  } catch (error) {
    console.error('Failed to save isBlocked:', error);
  }
};

export const getIsBlocked = () => {
  try {
    const isBlocked = Cookies.get('isBlocked');
    if (isBlocked !== undefined) {
      const blocked = isBlocked === 'true';
      console.log('isBlocked retrieved successfully:', blocked);
      return blocked;
    }
    return false; // Default to false if not set
  } catch (error) {
    console.error('Failed to get isBlocked:', error);
    return false;
  }
};

export const removeIsBlocked = () => {
  try {
    Cookies.remove('isBlocked', { path: '/' });
    console.log('isBlocked removed successfully');
  } catch (error) {
    console.error('Failed to remove isBlocked:', error);
  }
};

// Function to update isBlocked cookie and trigger a custom event
export const updateIsBlocked = (isBlocked) => {
  try {
    saveIsBlocked(isBlocked);
    // Dispatch custom event to notify components about blocked state change
    window.dispatchEvent(new CustomEvent('isBlockedChanged', { detail: { isBlocked } }));
    console.log('isBlocked updated and event dispatched:', isBlocked);
  } catch (error) {
    console.error('Failed to update isBlocked:', error);
  }
};

// Function to check if user is currently blocked
export const isUserBlocked = () => {
  return getIsBlocked();
};



export const saveSubscriptionActive = (status) => {
  try {
    Cookies.set('subscription_active', status.toString(), { expires: 7 });
    console.log('subscription_active saved:', status);
  } catch (error) {
    console.error('Failed to save subscription_active:', error);
  }
};

export const saveIsEssayAllowed = (status) => {
  try {
    Cookies.set('is_essay_allowed', status.toString(), { expires: 7 });
    console.log('is_essay_allowed saved:', status);
  } catch (error) {
    console.error('Failed to save is_essay_allowed:', error);
  }
};

export const saveEssaysAllowed = (count) => {
  try {
    Cookies.set('essays_allowed', count.toString(), { expires: 7 });
    console.log('essays_allowed saved:', count);
  } catch (error) {
    console.error('Failed to save essays_allowed:', error);
  }
};


export const getSubscriptionActive = () => {
  try {
    const value = Cookies.get("subscription_active");
    return value === "true"; // boolean return karega
  } catch (error) {
    console.error("Failed to get subscription_active:", error);
    return false;
  }
};

export const getIsEssayAllowed = () => {
  try {
    const value = Cookies.get("is_essay_allowed");
    return value === "true";
  } catch (error) {
    console.error("Failed to get is_essay_allowed:", error);
    return false;
  }
};

export const getEssaysAllowed = () => {
  try {
    const value = Cookies.get("essays_allowed");
    return value ? parseInt(value, 10) : 0;
  } catch (error) {
    console.error("Failed to get essays_allowed:", error);
    return 0;
  }
};


export const removeEssayCookies = () => {
  Cookies.remove('subscription_active');
  Cookies.remove('is_essay_allowed');
  Cookies.remove('essays_allowed');
};




export const clearAllAuthCookies = () => {
  try {
    removeToken();
    removeIsBlocked();
        removeEssayCookies();

    console.log('All auth cookies cleared successfully');
  } catch (error) {
    console.error('Failed to clear auth cookies:', error);
  }
}; 